import { useFormContext } from 'react-hook-form';

import {
  type WorkRedistributeFormData,
  getTaskFrameInfo,
} from '@/component/Task';
import type { Task, TaskAllocation } from '@/type';

import { createTaskAllocations } from '../util';

export const useDistributeEvenly = (task: Task) => {
  const { watch } = useFormContext<WorkRedistributeFormData>();

  const distributeEvenly = (): TaskAllocation[] => {
    const unAssignedUserID = watch('unAssignedUserID');
    const userTaskCount = task.userTask?.length ?? 0;
    const assignedUserCount = userTaskCount - unAssignedUserID.length;

    const frameInfo = getTaskFrameInfo(task, assignedUserCount);

    return createTaskAllocations({
      task,
      frameInfo,
      unAssignedUserID,
    });
  };

  return { distributeEvenly };
};
